export const REMAINING_STOCK_LIMIT = 10;
